import { render, staticRenderFns } from "./doser.vue?vue&type=template&id=53a25e59&"
import script from "./doser.vue?vue&type=script&lang=js&"
export * from "./doser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports